import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

const initialState: any = {
  menuPlans: [],
  loading: false,
  error: null,
};

// Async Thunks for fetching and saving Menu Plans
export const fetchInitiateMenuPlans = createAsyncThunk(
  'initiateMenuPlan/fetchInitiateMenuPlans',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/GetInitiateMenuPlanRegular`, payload);
    return response?.data?.data?.daypartmenulist;
  }
);

export const saveInitiateMenuPlans = createAsyncThunk(
  'initiateMenuPlan/saveInitiateMenuPlans',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/SaveInitiateMenuPlanRegular`, payload);
    return response?.data?.data?.daypartmenulist;
  }
);

export const fetchInitiateMenuPlanEvent = createAsyncThunk(
  'initiateMenuPlan/fetchInitiateMenuPlanEvents',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/GetInitiateMenuPlanEvents`, payload);
    return response?.data?.data?.daypartmenulist;
  }
);

export const saveInitiateMenuPlanEvent = createAsyncThunk(
  'initiateMenuPlan/saveInitiateMenuPlanEvents',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/SaveInitiateMenuPlanEvents`, payload);
    return response?.data?.data?.daypartmenulist;
  }
);

export const fetchInitiateMenuPlanBakery = createAsyncThunk(
  'initiateMenuPlan/fetchInitiateMenuPlanBakery',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/GetInitiateMenuPlanBakery`, payload);
    return response?.data?.data?.daypartmenulist;
  }
);

export const saveInitiateMenuPlanBakery = createAsyncThunk(
  'initiateMenuPlan/saveInitiateMenuPlanBakery',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/SaveInitiateMenuPlanBakery`, payload);
    return response?.data?.data?.daypartmenulist;
  }
);

export const fetchInitiateMenuPlanCombo = createAsyncThunk(
  'initiateMenuPlan/fetchInitiateMenuPlanCombo',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/GetInitiateMenuPlanCombo`, payload);
    return response?.data?.data?.daypartmenulist;
  }
);

export const saveInitiateMenuPlanCombo = createAsyncThunk(
  'initiateMenuPlan/saveInitiateMenuPlanCombo',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/SaveInitiateMenuPlanCombo`, payload);
    return response?.data?.data?.daypartmenulist;
  }
);

export const fetchInitiateMenuPlanFoodProgram = createAsyncThunk(
  'initiateMenuPlan/fetchInitiateMenuPlanFoodProgram',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/GetInitiateFoodProgramMenu`, payload);
    return response?.data?.data?.daypartmenulist;
  }
);

export const saveInitiateMenuPlanFoodProgram = createAsyncThunk(
  'initiateMenuPlan/saveInitiateMenuPlanFoodProgram',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/SaveInitiateMenuFoodProgram`, payload);
    return response?.data?.data?.daypartmenulist;
  }
);

const initiateMenuPlanSlice = createSlice({
  name: 'InitiateMenuPlan',
  initialState,
  reducers: {
    // Custom reducer to clear the menuPlans array
    clearMenuPlans: (state) => {
      state.menuPlans = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInitiateMenuPlans.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInitiateMenuPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlans = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchInitiateMenuPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(saveInitiateMenuPlans.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveInitiateMenuPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlans = state.menuPlans.map((plan: any) =>
          plan.daypartcode === action.payload[0].daypartcode
            ? { ...plan, ...action.payload[0] } // Update matching object
            : plan // Keep unchanged objects
        );
      })
      .addCase(saveInitiateMenuPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    // events
    builder
      .addCase(fetchInitiateMenuPlanEvent.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInitiateMenuPlanEvent.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlans = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchInitiateMenuPlanEvent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(saveInitiateMenuPlanEvent.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveInitiateMenuPlanEvent.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlans = state.menuPlans.map((plan: any) =>
          plan.daypartcode === action.payload[0].daypartcode
            ? { ...plan, ...action.payload[0] } // Update matching object
            : plan // Keep unchanged objects
        );
      })
      .addCase(saveInitiateMenuPlanEvent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    // Handle Bakery
    builder
      .addCase(fetchInitiateMenuPlanBakery.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInitiateMenuPlanBakery.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlans = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchInitiateMenuPlanBakery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(saveInitiateMenuPlanBakery.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveInitiateMenuPlanBakery.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlans = state.menuPlans.map((plan: any) =>
          plan.daypartcode === action.payload[0].daypartcode
            ? { ...plan, ...action.payload[0] } // Update matching object
            : plan // Keep unchanged objects
        );
      })
      .addCase(saveInitiateMenuPlanBakery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    // Combo
    builder
      .addCase(fetchInitiateMenuPlanCombo.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInitiateMenuPlanCombo.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlans = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchInitiateMenuPlanCombo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(saveInitiateMenuPlanCombo.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveInitiateMenuPlanCombo.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlans = state.menuPlans.map((plan: any) =>
          plan.daypartcode === action.payload[0].daypartcode
            ? { ...plan, ...action.payload[0] } // Update matching object
            : plan // Keep unchanged objects
        );
      })
      .addCase(saveInitiateMenuPlanCombo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    // Food Program
    builder
      .addCase(fetchInitiateMenuPlanFoodProgram.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInitiateMenuPlanFoodProgram.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlans = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchInitiateMenuPlanFoodProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(saveInitiateMenuPlanFoodProgram.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveInitiateMenuPlanFoodProgram.fulfilled, (state, action) => {
        state.loading = false;
        state.menuPlans = state.menuPlans.map((plan: any) =>
          plan.daypartcode === action.payload[0].daypartcode
            ? { ...plan, ...action.payload[0] } // Update matching object
            : plan // Keep unchanged objects
        );
      })
      .addCase(saveInitiateMenuPlanFoodProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// Export the custom action `clearMenuPlans` to be dispatched
export const { clearMenuPlans } = initiateMenuPlanSlice.actions;
export default initiateMenuPlanSlice.reducer;
